var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import SeparatorCore from '@core-front/separator';
const Separator = (props) => {
    const { theme, color } = props, rest = __rest(props, ["theme", "color"]);
    let additionalProps = {};
    if (color === 'dark-medium') {
        additionalProps = { color: 'medium', 'data-theme': 'dark' };
    }
    else if (color === 'dark-strong') {
        additionalProps = { color: 'strong', 'data-theme': 'dark' };
    }
    else if (color === 'dark') {
        additionalProps = { 'data-theme': 'dark' };
    }
    else {
        additionalProps = { color: color, 'data-theme': theme };
    }
    return React.createElement(SeparatorCore, Object.assign({}, rest, additionalProps));
};
export { Separator as default };
